import { Injectable, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../shared/base.service";
import { ResultBase } from "../../../core/models/result-base";
import { FormFolder } from "../../models/physician/form-folder";
import { FormDoc } from "../../models/physician/form-doc";
import {
  FormDocBuilder,
  PatientInfoOption,
} from "../../models/physician/form-doc-builder";
import { shareReplay, map } from "rxjs/operators";
import { UserService } from "./user.service";
import { DynamicFormHeader } from "../../models/physician/dynamicFormHeader";
import { FormList } from "../../model/v2/appointment/form-list";
import { PdfForm } from "../../models/physician/pdfform";

export class FormbaseService {
  constructor(
    private _baseService: BaseService,
    private _userService: UserService
  ) {
    // this.formServiceSetup();
  }
  controllerName: string = "Form";
  spaFormDetailsRoute: string = "physician/forms/details/";

  //#region "Cached methods"
  patientInfoItems$: Observable<PatientInfoOption[]>;

  getPatientInformationItemOptionsAll(): Observable<PatientInfoOption[]> {
    //could be moved to commons
    if (!this.patientInfoItems$)
      this.patientInfoItems$ = this._baseService
        .get<PatientInfoOption[]>(`Form/PatientInformationItemOptions`)
        .pipe(shareReplay(50));

    return this.patientInfoItems$;
  }

  clearAllCodesCache() {
    this.patientInfoItems$ = null;
  }

  // formServiceSetup()
  // {

  //   this._userService.getUserDetails().toPromise().then(
  //     (user) =>
  //     {
  //       if(user.role == "AHIAdministrator")
  //       {
  //         this.controllerName = "TemplateForm";
  //         this.spaFormDetailsRoute = "admin/manageTemplateForms/details/";
  //       }
  //       else
  //       {
  //         this.controllerName = "Form";
  //         this.spaFormDetailsRoute = "physician/forms/details/";
  //       }
  //     }

  //     );
  // }

  //#region "shared"
  getFormDoc(formId: number): Observable<ResultBase<FormDoc>> {
    return this._baseService.get<ResultBase<FormDoc>>(
      `${this.controllerName}/${formId}`
    );
  }

  getFormBuilder(formId: number): Observable<ResultBase<FormDocBuilder>> {
    return this._baseService.get<ResultBase<FormDocBuilder>>(
      `${this.controllerName}/${formId}/FormBuilderDto`
    );
  }

  getStaticFormPreview(
    formId: number,
    formName: string
  ): Observable<ResultBase<FormDocBuilder>> {
    return this._baseService.get<ResultBase<FormDocBuilder>>(
      `${this.controllerName}/${formName}/GetFixedFormHtmlByFormname`
    );
  }

  getHTMLPreview(): Observable<ResultBase<DynamicFormHeader>> {
    return this._baseService.get<ResultBase<DynamicFormHeader>>(
      `${this.controllerName}/GetDynamicFormHeader`
    );
  }

  getFormsList(): Observable<ResultBase<FormList[]>> {
    return this._baseService.get<ResultBase<FormList[]>>(
      `${this.controllerName}/GetFormsByHealthOrgid`
    );
  }

  getPdfFormsByPatientId(patientId: number): Observable<any> {
    return this._baseService.get(
      `${this.controllerName}/GetPdfFormsByPatientId?pattientId=${patientId}`
    );
  }

  getFormPreviewHtml(formId: number): Observable<Blob> {
    return this._baseService.getBlob(`${this.controllerName}/${formId}/html`);
  }

  generateFormPeviewHtml(formBuilderDto: FormDocBuilder): Observable<Blob> {
    return this._baseService.postAndGetBlob(
      `${this.controllerName}/GenerateHTML`,
      formBuilderDto
    );
  }
  getFormsDocs(searchText: string): Observable<ResultBase<FormFolder[]>> {
    return this._baseService.get<ResultBase<FormFolder[]>>(
      `${this.controllerName}/folders?filterWord=${searchText}`
    );
  }

  getFormsGroups(): Observable<ResultBase<FormFolder[]>> {
    return this._baseService.get<ResultBase<FormFolder[]>>(
      `${this.controllerName}/FormGroup`
    );
  }

  getPatientInformationItemOptions(): Observable<PatientInfoOption[]> {
    return this._baseService.get<PatientInfoOption[]>(
      `${this.controllerName}/PatientInformationItemOptions`
    );
  }
  //#region "Specific Actions"

  uploadHeaderPicture(
    formId: number,
    formPicture: FormData
  ): Observable<ResultBase<string>> {
    return this._baseService.upload<ResultBase<string>>(
      `${this.controllerName}/${formId}/UploadHeaderImage`,
      formPicture
    );
  }
  uploadFooterPicture(
    formId: number,
    formPicture: FormData
  ): Observable<ResultBase<string>> {
    return this._baseService.upload<ResultBase<string>>(
      `${this.controllerName}/${formId}/UploadFooterImage`,
      formPicture
    );
  }
  //#endregion

  //#region "Additions"
  addFormDoc(request: FormDoc): Observable<ResultBase<FormDoc>> {
    const docForm: FormData = new FormData();
    docForm.append("File", request.file, request.file.name);
    docForm.append("formGroupId", request.formGroupId.toString());
    docForm.append("title", request.title);
    docForm.append("summary", request.summary);
    docForm.append("code", request.code);
    console.log(request);
    if (!request.id) {
      return this._baseService.upload<any>(`Form/AddPdfForm`, docForm);
    } else {
      docForm.append("id", request.id.toString());
      return this._baseService.upload<any>(`Form/UpdatePdfForm`, docForm);
    }
    //return addPdfForm(formDoc);
    // this._baseService.post<ResultBase<FormDoc>>(
    //   `${this.controllerName}`,
    //   formDoc
    // );
  }
  addFormFolder(formFolder: FormFolder): Observable<ResultBase<FormFolder>> {
    return this._baseService.post<ResultBase<FormFolder>>(
      `${this.controllerName}/FormGroup`,
      formFolder
    );
  }
  //#endregion

  saveHeaderDesignHtml(
    dynamicFormHeader: DynamicFormHeader
  ): Observable<ResultBase<any>> {
    return this._baseService.post<ResultBase<any>>(
      `${this.controllerName}/SaveDynamicFormHeader`,
      dynamicFormHeader
    );
  }

  //#region "Updates"
  updateFormFolder(formFolder: FormFolder): Observable<ResultBase<FormFolder>> {
    return this._baseService.put<ResultBase<FormFolder>>(
      `${this.controllerName}/FormGroup/${formFolder.id}`,
      formFolder
    );
  }
  updateFormDoc(formDoc: FormDoc): Observable<ResultBase<FormDoc>> {
    return this._baseService.put<ResultBase<FormDoc>>(
      `${this.controllerName}/${formDoc.id}`,
      formDoc
    );
  }
  updateFormBuilder(
    formId: number,
    formBuilder: FormDocBuilder
  ): Observable<ResultBase<FormDocBuilder>> {
    return this._baseService.put<ResultBase<FormDocBuilder>>(
      `${this.controllerName}/${formId}/FormBuilderDto`,
      formBuilder
    );
  }
  updateRelatedFormFolders(
    formId: number,
    formGroups: number[]
  ): Observable<ResultBase<boolean>> {
    return this._baseService.post<ResultBase<boolean>>(
      `${this.controllerName}/${formId}/FormGroup`,
      formGroups
    );
  }
  //#endregion
  //#region "Removals"
  deleteFormFolder(formFolder: FormFolder): Observable<ResultBase<boolean>> {
    return this._baseService.delete<ResultBase<boolean>>(
      `${this.controllerName}/FormGroup/${formFolder.id}`
    );
  }
  deleteForm(formId: number): Observable<ResultBase<boolean>> {
    return this._baseService.delete<ResultBase<boolean>>(
      `${this.controllerName}/${formId}`
    );
  }
  //#endregion

  //#endregion

  getContentTypeOptions() {
    return [
      { id: "InputText", text: "Input Text" },
      { id: "InputNumber", text: "Input Number" },
      { id: "InputDate", text: "Input Date" },
      { id: "SelectOption", text: "Select Option" },
      { id: "InputData", text: "Input User Data (Profile)" },
      { id: "Paragraph", text: "Paragraph (read only)" },
      { id: "Signature", text: "Signature" },
      { id: "Decision", text: "Decision (A/B)" },
    ];
  }

  getTemplateFormPreviewHtml(formId: number): Observable<Blob> {
    return this._baseService.getBlob(`Form/Template/${formId}/html`);
  }
}

@Injectable({
  providedIn: "root",
})
export class TemplateFormService extends FormbaseService {
  constructor(
    private baseService: BaseService,
    private userService: UserService
  ) {
    super(baseService, userService);
    this.controllerName = "TemplateForm";
    this.spaFormDetailsRoute = "admin/manageTemplateForms/details/";
  }
}

@Injectable({
  providedIn: "root",
})
export class FormService extends FormbaseService {
  activeFormFolders: FormFolder[];
  constructor(
    private baseService: BaseService,
    private userService: UserService
  ) {
    super(baseService, userService);
    this.controllerName = "Form";
    this.spaFormDetailsRoute = "physician/forms/details/";
  }

  cloneToHOForm(templateFormId: number): Observable<ResultBase<FormDoc>> {
    return this.baseService.post<ResultBase<FormDoc>>(
      `Form/Template/${templateFormId}/CloneToHO`,
      {}
    );
  }
  getFormsTemplates(searchText: string): Observable<ResultBase<FormFolder[]>> {
    return this.baseService.get<ResultBase<FormFolder[]>>(
      `Form/template/folders?filterWord=${searchText}`
    );
  }

  getTemplateFormDoc(formId: number): Observable<ResultBase<FormDoc>> {
    return this.baseService.get<ResultBase<FormDoc>>(`Form/Template/${formId}`);
  }

  getContentTypeOptions() {
    return [
      { id: "InputText", text: "Input Text" },
      { id: "InputNumber", text: "Input Number" },
      { id: "InputDate", text: "Input Date" },
      { id: "SelectOption", text: "Select Option" },
      { id: "InputData", text: "Input User Data (Profile)" },
      { id: "Paragraph", text: "Paragraph (read only)" },
      { id: "Signature", text: "Signature" },
      { id: "Decision", text: "Decision (A/B)" },
    ];
  }
  addPdfForm(request: PdfForm): Observable<any> {
    const docForm: FormData = new FormData();
    docForm.append("File", request.file, request.file.name);
    docForm.append("formGroupId", request.formGroupId.toString());
    docForm.append("title", request.title);
    docForm.append("summary", request.summary);

    return this.baseService.upload<any>(`Form/AddPdfForm`, docForm);
  }
  getAcrFormsFields(): Observable<any> {
    return this.baseService.get<any>(`Form/GetAcroformFieldMappingInfo`);
  }
  //#endregion
}

@Injectable({
  providedIn: "root",
})
export class FormServiceResolver {
  constructor(
    private templateFormService: TemplateFormService,
    private formService: FormService,
    private userService: UserService
  ) {}

  getFormDetailsRoute(): Observable<string> {
    return this.getFormService().pipe(map((x) => x.spaFormDetailsRoute));
  }

  getFormService(): Observable<FormService | TemplateFormService> {
    var obs = new Observable<FormService | TemplateFormService>((observer) => {
      this.userService.getUserDetails().subscribe(
        (user) => {
          if (user.role == "AHIAdministrator") {
            observer.next(this.templateFormService);
          } else {
            observer.next(this.formService);
          }
        },
        (error) => {
          observer.error(error);
        },
        () => observer.complete()
      );
    });

    return obs;
  }
}
